function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.84717 18.5411C7.94597 19.9328 9.64814 20.826 11.5589 20.826H16.5001C19.8138 20.826 22.5001 18.1397 22.5001 14.826V8.04344C22.5001 5.55321 20.983 3.4173 18.8227 2.50952C19.1449 3.24548 19.3236 4.05852 19.3236 4.91331V12.7393C19.3236 16.053 16.6373 18.7393 13.3236 18.7393H8.38244C7.85177 18.7393 7.3372 18.6704 6.84717 18.5411Z",
  fill: "#00C1F6"
});

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 14.0293,
  cy: 6.73905,
  rx: 2.11765,
  ry: 2.08695,
  fill: "#00C1F6"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 5.25,
  y: 1.75,
  width: 15.4412,
  height: 18.326,
  rx: 5.25,
  stroke: "#26282C",
  strokeWidth: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("mask", {
  id: "path-4-inside-1",
  fill: "white"
}, /*#__PURE__*/React.createElement("rect", {
  x: 8.73535,
  y: 12.478,
  width: 8.47059,
  height: 5.21737,
  rx: 1
}));

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 8.73535,
  y: 12.478,
  width: 8.47059,
  height: 5.21737,
  rx: 1,
  stroke: "#26282C",
  strokeWidth: 3,
  mask: "url(#path-4-inside-1)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M14.8678 7.78276C14.8678 8.799 14.0289 9.64144 12.9708 9.64144C11.9127 9.64144 11.0737 8.799 11.0737 7.78276C11.0737 6.76652 11.9127 5.92407 12.9708 5.92407C14.0289 5.92407 14.8678 6.76652 14.8678 7.78276Z",
  stroke: "#26282C",
  strokeWidth: 1.5
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M9.79392 20.3042L7.67627 24.9998",
  stroke: "#26282C",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9707 20.3042V24.9998",
  stroke: "#26282C",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M16.147 20.3042L18.2646 24.9998",
  stroke: "#26282C",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M4.81583 0.999925L4.78278 2.36379",
  stroke: "#FFC100",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M2.28809 1.97046L3.3412 2.98307",
  stroke: "#FFC100",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M1.5 4.57202L2.63107 4.37594",
  stroke: "#FFC100",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgCheerzLive(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheerzLive);
export default __webpack_public_path__ + "static/media/cheerz-live.cd07ba32.svg";
export { ForwardRef as ReactComponent };